<template>
  <div class="site_scan_list">
    <div class="errmsg-box border_box" v-if="errmsg === 20001">
      <img src="../../assets/images/fixedstatementerror/tips.png" alt="">
      <div class="tips-box border_box">
        <p>本月网站扫描结果已刷新，</p>
        <p>暂不支持查看往月网站扫描结果</p>
      </div>
    </div>
    <div class="errmsg-box border_box" v-if="errmsg === 20010 || errmsg === 20011">
      <img src="../../assets/images/fixedstatementerror/tips.png" alt="">
      <div class="tips-box border_box">
        <p>您的账号已停用</p>
        <p>请联系您的销售顾问<span>及时续约</span></p>
      </div>
    </div>
    <div class="errmsg-box border_box" v-if="errmsg === 20012">
      <img src="../../assets/images/fixedstatementerror/tips.png" alt="">
      <div class="tips-box border_box">
        <p>您的账号已弃用</p>
        <p>请联系您的销售顾问<span>及时续约</span></p>
      </div>
    </div>
    <div class="errmsg-box border_box" v-if="errmsg === 20013 || errmsg === 20017">
      <img src="../../assets/images/fixedstatementerror/tips.png" alt="">
      <div class="tips-box border_box">
        <p>请扫码绑定网媒账号对应的预警推送公众号后</p>
        <p>重新打开查看</p>
      </div>
    </div>
    <div class="errmsg-box border_box" v-if="errmsg === 20016">
      <img src="../../assets/images/fixedstatementerror/tips.png" alt="">
      <div class="tips-box border_box">
        <p>系统链接暂不支持分享查看</p>
        <p>如需分享请复制分享原文链接</p>
      </div>
    </div>
    <template>
      <div v-if="showListData" class="site_scan_list_title mt40">网站扫描结果列表</div>
      <div class="site_scan_list_btn_warp flex-wrap-start">
        <div v-for="(item,index) in btnList" :key="index" class="list_btn" :class="params.webStatus === item.type2 ? 'hover': ''" @click.stop="tagBtn(item)">
          <p>{{ item.name }}</p>
          <!-- <p>({{ item.count }})</p> -->
        </div>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finished_text"
        @load="getListData"
      >
        <div v-for="(item,index) in listData" :key="index" class="list_ul">
          <div class="list_title">
            <div class="title ellipsis-1">{{ item.siteName }}</div>
          </div>
          <div class="list_url ellipsis-1 mt10">{{ item.siteDomain }}</div>
          <!-- <div v-if="params.webStatus !== '7'&& params.webStatus !== '8'" class="flex-between mt10">
            <div v-for="(it,index) in item.typeNameList" :key="index" class="type">{{ it.name }}</div>
          </div>
          <div v-else class="flex-between mt10"><div class="type mt10">{{ scanResultMap[item.scanRes] }}</div></div> -->
          <div class="flex-wrap-start mt10">
            <div v-for="(it,index) in item.typeNameList" :key="'type'+index" class="type mr10 mb10">{{ it.name }}</div>
          </div>
        </div>
      </van-list>
      <div class="border_box" v-show="finished && listData.length === 0">
        <div class="nodata-box">
          <p>暂无数据</p>
        </div>
      </div>
      <!-- <div class="border_box" v-show="finished && noData">
        <div class="nodata-box">
          <p>暂无数据</p>
        </div>
      </div> -->
    </template>
  </div>
</template>

<script>
import { List, Toast } from 'vant';
import { getList,getDistribution, getCode } from '@/api/wmsitescan'
export default {
  name:'siteScan',
  components: {
    "van-list": List,
  },
  data(){
    return {
      errmsg: 0, // 错误信息值 200无错
      btnList: [],
      typeMap:{
        0: '全部',
        5: '涉黄',
        6: '涉毒',
        7: '无法访问',
        10: '涉政',
        11: '涉民族宗教',
        12: '涉暴恐',
      },
      scanResultMap: {
        1: '通过',
        2: '单项否决',
        3: '无法访问'
      },
      loading: false,          //暂停加载数据
      finished: false,         //终止加载数据
      finished_text: '',
      showListData: false,    //是否展示列表
      listData:[],
      params: {
          state:'',
          pageSize: 10,         // 每页条数
          pageNo: 0,           //页码
          webStatus: ''
      },
      noData:false,
    }
  },
  created(){
    // 固定表述错误页面，更改网页ico
    let pageUrl = this.$route.path
    if(pageUrl === '/siteScan'){
      document.querySelector("link.linkico").href = "./wmico.ico";
    }else{
      document.querySelector("link.linkico").href = "./favicon.ico";
    }
  },
  mounted(){
    if (localStorage.getItem("wlgl-token")) {
      this.getTabData()
    }else if (!!localStorage.getItem("wlgl-token") == '' && Object.keys(this.$route.query).length === 0){
      this.errmsg = 20016
    }else{
      this.init()
    }
  },
  methods:{
    init(){
      if (Object.keys(this.$route.query).length) {
        const code = this.$route.query.code
        const state = this.$route.query.state
        this.queryCode(code,state)
      }
    },
    queryStatus(){
      let status = '';
      if(this.$route.query.state.includes('_')){
        const statusArr = this.$route.query.state.split('_');
        status = statusArr[0];
      }else{
        status = this.$route.query.state
      }
      return status;
    },
    // 获取列表数据
    getListData() {
      if (!!localStorage.getItem("wlgl-token") == '' && Object.keys(this.$route.query).length === 0){
        this.errmsg = 20016
        return false
      }
      // 接口响应前，先显示加载中
      this.loading = true;
      this.params.pageNo = this.params.pageNo + 1
      // 本地联调时 可以使用this.$route.query.state|| 5 加微信推送信息token获取数据
      this.params.state =  this.queryStatus()
      getList(this.params).then(res=>{
        if(res.data.code === 200) {
          this.showListData = true
          // let total = res.data.data.total
          if (res.data.data.records && res.data.data.records.length > 0) {
            this.listData = [...this.listData, ...res.data.data.records]
            // if(this.listData.length === 0){
            //   this.noData = true;
            // }
            // if(this.listData.length >= total) {
            //   this.finished = true;
            // }
            if (res.data.data.records.length <10)  {
              this.finished = true;
            }
          } else {
            this.noData = true;
            this.finished = true;
          }
          // if(this.listData.length >0 && this.listData.length >= total && this.finished){
          if(this.listData.length > 0 && this.finished){
            this.finished_text = "没有更多了";
          } else {
            this.finished_text = "";
          }
          // 加载状态结束
          this.loading = false;
        }else if (res.data.code === 20009){
          this.showListData = false
          this.loading = false
          this.finished = true;
          this.finished_text = ''
          this.listData = []
          this.params = {
            state:'',
            pageSize: 10,
            pageNo: 0,
            webStatus: ''
          }
          // token 失效
          this.init()
        } else {
          // Toast.fail(res.data.message);
          // console.log(res.data.code);
          // console.log(res.data.message);
          this.errmsg = res.data.code
          this.showListData = false
          this.loading = false;
          this.finished = true;
          this.listData = [];
        }
      }).catch(err => {
        this.showListData = false
        this.loading = false;
        this.finished = true;
        this.listData = [];
        Toast.fail(err.message);
      });
    },
    // 获取筛选数据
    getTabData() {
      // 本地联调时 可以使用this.$route.query.state|| 5 加微信推送信息token获取数据
      getDistribution({
        state:  this.queryStatus()
      }).then(res=>{
        if(res.data.code === 200) {
          if(res.data.data && res.data.data.length>0) {
            res.data.data.forEach(item => {
              if (item.type === '0') {
                item.type2 = ''
              } else {
                item.type2 = item.type
              }
            })
            this.btnList = res.data.data
          } else {
            this.btnList = []
          }
        } else {
          this.btnList = []
          // Toast.fail(res.data.message);
        }
      })
    },
    // 筛选数据切换
    tagBtn(val) {
      if (val.type === '0' || val.type2 === '') {
        this.params.webStatus = ''
      } else {
        this.params.webStatus = val.type
      }
      this.listData = []
      this.params.pageNo = 0
      this.finished_text = ""
      this.finished = false
      this.getListData()
    },
     // 获取 wlgl-token
     queryCode(code,state){
      this.loading = true
      getCode({
        code: code,
        state: state
      }).then(res=>{
        this.loading = false;
        if (res.data.code === 200){
          localStorage.setItem("wlgl-token", res.data.data)
          this.listData = []
          this.params.pageNo = 0
          this.finished_text = ""
          this.finished = false
          this.getListData()
          this.getTabData()
        }else{
          this.errmsg = res.data.code
          // Toast.fail(res.data.message);
        }
      }).catch(err=>{
        this.loading = false;
        Toast.fail(err.message);
      });
    },
  }
}
</script>

<style scoped>
  @import url("./siteScan.css");
</style>
